jQuery(document).ready(function($){

    $('#sidebar1 .menu > li').each(function(){
        if ($(this).find('ul').hasClass('sub-menu')) {
            $(this).prepend('<div class="cat-menu-close"></div>'); 
        }
    });
    
    $('.cat-menu-close, .cat-menu-close + a').on('click',function(event){
       event.preventDefault();

       if ($(this).parent().hasClass('opened')) {
           $(this).parent().removeClass('opened');
           $(this).parent().find('.sub-menu').slideUp();
       } else {
           $(this).parent().addClass('opened');
           $(this).parent().find('.sub-menu').slideDown();
       }
    });

    $('.project-button.filter-button[data-open], .open-manufacture[data-open]').click(function() {
        var title = $(this).data('title');
        var sel = '#' + $(this).data('open') + ' #subject';
        var $el = $(sel);

        if ($el.length) {
            $el.val(title);
        }

    });

    $('#sidebar1 .menu-item-has-children.active').addClass('opened').find('.sub-menu').slideDown();

    function sidebar_add_view_all() {
        $('#sidebar1 .menu > .menu-item-has-children').each(function() {
            var $submenu = $(this).children('.sub-menu');
            var $link = $(this).children('a').clone();
            $submenu.append('<li class="view-all"></li>');
            $submenu.children('.view-all').append($link);
            $submenu.find('.view-all > a').text(tense_vars.view_all_caption);
        });
    }

    // sidebar_add_view_all();

});
